import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';


class Post extends Component {
  

  render() {
   // console.log(this.props.data)
    return (
      <div className="bw-box__card-container col-12 col-md-6 d-flex align-items-stretch">
        <div className="card bw-box__card w-100 mb-4">
          
          <div className="card-body bw-box__card-body">
            <h4 className="card-title bw-box__category">{this.props.categories}</h4>
            <div className="card-text bw-box__date py-1">{this.props.date}</div>
            <h3 className="card-title bw-box__title">{this.props.title}</h3>
          </div>
          <div className="card-footer bw-box__card-footer">
            <a className="btn btn-bw stretched-link mt-auto card-link" href={`${this.props.link}`} target="_blank" rel="noopener noreferrer">Read More</a>
          </div>
        </div>
      </div>
    );
  }
}

Post.propTypes = {
  data: PropTypes.array
};

const mapStateToProps = state => {
  return {
    data: state.postData.data
  };
};

export default connect(mapStateToProps)(Post);
